import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getItemWebStorage } from "../../../features/webStorageSaver/webStorageSaver";

export const tempDocumentsAPI = createApi({
    reducerPath: "tempDocumentsAPI",
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.NODE_ENV === "development"
            ? "/tempDocumentsService/api/"
            : "https://geo.indorsoft.ru/tempDocumentsService/api/",
        prepareHeaders: (headers) => {
            const token = getItemWebStorage("currentConfig")?.services?.tempDocuments?.openDataOptions?.badge?.badgeToken;
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            return headers;
        },
    }),
    endpoints: builder => ({}),
});

export const tempDocumentsAPIReducer = tempDocumentsAPI.reducer;
export const resetTempDocumentsAPI = tempDocumentsAPI.util.resetApiState;
